import { HighlightsText } from '@features/campaigns/domain/text/highlights-text';
import { RslReport } from '../../api/schema';
import { formatters } from '@utils/formattersV2';
import { nanoid } from 'nanoid';

type RslInput = Pick<
  RslReport,
  | 'incrementalSalesLift'
  | 'projectedIncrementalSales'
  | 'totalProjectedSales'
  | 'uniqueUsers'
>;

export const highlightsText: HighlightsText<RslInput> = props => {
  const usersString = formatters.users(props.metrics.uniqueUsers, {
    full: true,
  });
  const totalProjectedSalesString = formatters.currency(
    props.metrics.totalProjectedSales,
    { full: true, decimals: 0 }
  );
  const incrementalSalesLiftString = formatters.lift(
    props.metrics.incrementalSalesLift
  );
  const incrementalSalesString = formatters.currency(
    props.metrics.projectedIncrementalSales,
    { full: true, decimals: 0 }
  );

  return [
    'The ',
    props.campaignName,
    ' campaign reached ',
    props.formatValues.uniqueUsers(usersString, nanoid()),
    ' users who purchased ',
    props.formatValues.totalProjectedSales(totalProjectedSalesString, nanoid()),
    ' after being exposed. Compared to control, the matched exposed users had ',
    props.formatValues.incrementalSalesLift(
      incrementalSalesLiftString,
      nanoid()
    ),
    ' more purchases which is indicated by the Incremental Sales Lift. The campaign generated ',
    props.formatValues.projectedIncrementalSales(
      incrementalSalesString,
      nanoid()
    ),
    ' in Incremental Sales that would not have occurred without exposure to this campaign.',
  ];
};
